module.exports = __webpack_public_path__ + "img/bg_logo.8090a5d6.png";